import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {Observable} from 'rxjs';
import {DocumentViewerAction} from '../../../../lib-core/components/documentViewer/documentViewer.component';
import {DownloadService} from '@lv1871/core';

export enum ExternalResourceDialogAction {
  Download = 'Download'
}

@Component({
    selector: 'lv-external-resource-dialog',
    templateUrl: './external-resource-dialog.component.html',
    styleUrls: ['./external-resource-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ExternalResourceDialogComponent implements OnInit {

  public header: string;
  public srcUrl: SafeResourceUrl;
  public loading: boolean;
  public isPdf: boolean;
  public pdfDocument$: Observable<ArrayBuffer>;
  public actions = [
    new DocumentViewerAction(ExternalResourceDialogAction.Download, 'COMMON.DOCUMENT_VIEWER.ACTIONS.DOWNLOAD_PDF', 'Download'),
  ];

  constructor(private _http: HttpClient, public dialogRef: MatDialogRef<ExternalResourceDialogComponent>,
              private readonly _downloadService: DownloadService,
              @Inject(MAT_DIALOG_DATA) public data: any, private _domSanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.header = this.data.header;
    if (!!this.data.filename && this.data.filename.toLowerCase().indexOf('.pdf') >= 0) {
      this.isPdf = true;
      this.loading = true;
      this.pdfDocument$ = new Observable<ArrayBuffer>(observer => {
        const fileReader = new FileReader();
        fileReader.onload = (event: any) => observer.next(event.target.result);
        fileReader.readAsArrayBuffer(this.data.blob);
      });
    } else {
      this.srcUrl = this._domSanitizer.bypassSecurityTrustResourceUrl(this.data.externalResourceUrl);
    }
  }

  public onDocumentViewerSuccessful(event: boolean) {
    if (event) {
      this.loading = false;
    }
  }

  public executeAction(action: DocumentViewerAction): void {
    switch (action.id) {
      case ExternalResourceDialogAction.Download:
        this._saveFileOrOpenNewWindow();
        break;
    }
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  private _saveFileOrOpenNewWindow() {
    this._downloadService.saveOrOpenFile(this.header, new Blob([this.data.blob],
        {type: 'application/pdf'}));
  }
}
